import {
  AccountDimensionSettingFindDto,
  type AccountDimensionSettingFindInterface,
} from '@zaoblako/shared/modules/catalog/dtos/account-dimension-setting/account-dimension-setting-find.dto';
import { ContragentFindDto, type ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import { WarehouseFindDto, type WarehouseFindInterface } from '@zaoblako/shared/modules/catalog/dtos/warehouse/warehouse-find.dto';
import { CostItemFindDto, type CostItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/cost-item/cost-item-find.dto';
import {
  OtherFinancialFlowFindDto,
  type OtherFinancialFlowFindInterface,
} from '@zaoblako/shared/modules/catalog/dtos/other-financial-flow/other-financial-flow-find.dto';
import { CashFlowItemFindDto, type CashFlowItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/cash-flow-item/cash-flow-item-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import type { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';

import * as yup from 'yup';

/** Direction balance sheet settings response body - DTO signature */
export interface DirectionBalanceSheetSettingsFindInterface {
  /** Account dimension setting */
  setting: AccountDimensionSettingFindInterface;
  /** Counterparties for balance sheet */
  contragents: ContragentFindInterface[];
  /** Contracts for balance sheet */
  contracts: ContractFindInterface[];
  /** Warehouses for balance sheet */
  warehouses: WarehouseFindInterface[];
  /** Cost items for balance sheet */
  costItems: CostItemFindInterface[];
  /** Other financial flows for balance sheet */
  otherFinancialFlows: OtherFinancialFlowFindInterface[]
  /** Cash/flow items for balance sheet */
  cashFlowItems: CashFlowItemFindInterface[];
}

/** Direction balance sheet settings response body - DTO schema */
export const DirectionBalanceSheetSettingsFindDto = SerdeDtoClass.create<DirectionBalanceSheetSettingsFindInterface>(
  CatalogDtosKeysEnum.DIRECTION_BALANCE_SHEET_SETTINGS_FIND_DTO,
  {
    setting: {
      label: 'Субконто',
      nested: AccountDimensionSettingFindDto,
      serializer: (_, nested) => nested,
    },
    contragents: {
      label: 'Контрагенты',
      nested: ContragentFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    contracts: {
      label: 'Договоры',
      nested: DocumentDtoKeysEnum.CONTRACT_FIND_DTO,
      serializer: (_, nested) => yup.array(nested),
    },
    warehouses: {
      label: 'Склады',
      nested: WarehouseFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    costItems: {
      label: 'Статьи затрат',
      nested: CostItemFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    otherFinancialFlows: {
      label: 'Прочие доходы и расходы',
      nested: OtherFinancialFlowFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    cashFlowItems: {
      label: 'Статьи движения денежных средств',
      nested: CashFlowItemFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
